import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { CookieAdapterService } from './cookie-adapter.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    CookieService,
    CookieAdapterService
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./ts/app/core/core.module.ts